export default __webpack_public_path__ + "static/media/427.fa9dce37.gif";